<template>
    <transition mode="in-out"
        @enter="enter"
        @leave="leave"
        @afterLeave="destroy">
        <div v-show="visible"
            :class="[
                'pp-message',
                `pp-message--${position}`,
                customClass || '',
            ]"
            :style="messageStyle">
            <i v-if="type !== 'info'" 
                :class="[
                    iconClass,
                    'pp-message__icon',
                ]"
            ></i>
            <span class="pp-message__content">{{message}}</span>
        </div>
    </transition>
</template>

<script>
/**
 * 消息弹窗Message
 * @param {String} customClass 样式css
 * @param {String} type 类型['info'(default), 'success', 'warning', 'error']
 * @param {String} message 消息文本
 * @param {[Number, String]} duration 延时消失时间，为0时不消失
 * @param {String} position 弹窗位置['top', 'center'(default), 'bottom']
 */
export default {
    name: 'pp-message-box',
    props: {
        customClass: String,
        type: {
            type: String,
            default: 'info',
            validator: function(value) {
                return ['info', 'success', 'warning', 'error'].includes(value);
            }
        },
        message: {
            type: String,
            default: '',
        },
        duration: {
            type: [Number, String],
            default: 3000,
        },
        position: {
            type: String,
            default: 'center',
            validator: function(value) {
                return ['top', 'center', 'bottom'].includes(value);
            }
        },
    },
    data: function() {
        return {
            visible: false,
            messageStyle: {},
            timer: '',
        };
    },
    computed: {
        iconClass: function() {
            switch(this.type) {
                default:
                    //no break
                case 'info':
                    return '';
                    break;
                case 'success':
                    return 'pp-icon-success';
                    break;
                case 'warning':
                    return 'pp-icon-warning';
                    break;
                case 'error':
                    return 'pp-icon-close-circle';
                    break;
            }
        },
    },
    watch: {
        visible: function(n) {
            if(n) {
                this.$nextTick(()=> {
                    this.messageStyle = this.computedStyle()
                })
                if(this.duration !== 0) {
                    this.timer = setTimeout(()=> {
                        this.close()
                    }, this.duration)
                }
            }
        },
    },
    methods: {
        computedStyle: function() {
            let style = {};
            let width = this.$el.offsetWidth;
            let height = this.$el.offsetHeight;
            
            style.left = '50%'
            style.marginTop = `-${height / 2}px`
            style.marginLeft = `-${width / 2}px`
            
            return style;
        },

        close: function() {
            clearTimeout(this.timer)
            this.visible = false
        },

        destroy: function() {
            this.$destroy(true)
            this.$el.parentNode.removeChild(this.$el)
        },

        enter: function(el) {
            if(this.position === 'center') {
                el.style.opacity = 1;
            }
            else {
                el.style[this.position] = window.innerHeight * .2 + 'px';
                el.style.transitionDuration = '.5s'
            }
        },

        leave: function(el) {
            if(this.position === 'center') {
                el.style.opacity = 0;
            }
            else {
                el.style[this.position] = 0;
                el.style.transitionDuration = '0'
            }
        },
    },
}
</script>
